export const CottaDescriptionBody = ({ bod }) => {
  return (
    <div className="description-section-two">
      The availability of media representing the black community does not
      currently meet its demand.
      <br />
      <br />
      There’s power in numbers. Uniting the creative talent that exists across
      the black community globally, the goal is to economically empower creators
      directly through image licensing and also by leveraged exposure and
      networking opportunities.
      <br />
      <br />
      What Cotta will achieve can ultimately be embodied by three pillars:
      <br />
      <br />
      <b>Empowering photographers</b> by curating the platform which will
      enhance their exposure, at the same time as inviting them into a rich
      network of peers, audiences, clients, and partners.
      <br />
      <br />
      <b>Delivering high resolution images</b>, providing quality resources
      which will benefit an ecosystem of hobbyists, designers, brands &amp;
      businesses, and media agencies of all scales.
      <br />
      <br />
      <b>Sharing authentic culture</b>, supporting photographers in freely
      sharing their essence, which gifts creators with the power of the
      narratives. Allowing stories to be told by those who truly live them, all
      across the world.
      <br />
      <br />
      In a generation that’s fuelled by visual media, creators can take control
      of our own narratives, share stories from our perspectives and immortalise
      our lived experiences into history. We are all creators.
    </div>
  );
};
